<template>
  <div class="pop">
    <div class="box">
      <div class="text1">
        交管车辆查询校验
      </div>
      <div class="text2" style="padding-bottom:0;">
        客户您好，请您协助完成图形验证码确认
      </div>
      <div class="text2">
        如验证码看不请，点击图片可更换
      </div>
      <div class="index">
        <input v-model="yzmCode" type="text" class="inputtext" placeholder="请输入图片中验证码">
        <img alt="" class="photo" :src="yzm" @click="changeYZM">
      </div>
      <span v-show="error" class="error">请输入验证码</span>
      <div class="flex">
        <span class="lefttxt" @click="showFalse">取消</span>
        <span class="righttxt" @click="submit">提交</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    yzm: {
      type: String
    },
    yzmNum: {
      type: String
    }
  },
  data() {
    return {
      error: false,
      yzmCode: this.yzmNum
    }
  },
  methods: {
    changeYZM() {
      this.$parent.checkout()
    },
    submit() {
      if (this.yzmCode === '') {
        this.error = true
      } else {
        this.$emit('submitResult', this.yzmCode)
        this.yzmCode = ''
      }
    },
    showFalse() {
      this.$emit('cancle')
    }
  }
}
</script>
<style lang="scss" scoped>
 @import "./checkCode.scss"
</style>



// WEBPACK FOOTER //
// src/components/CheckCode/index.vue